import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div`
  position: relative;

  .toast {
    bottom: calc(100% + ${rem(8)});
    color: ${({ theme }) => theme.palette.common.black};
    max-width: var(--toast-max-width);
    min-width: auto;
    position: absolute;
    z-index: 9999;
    width: max-content;

    @media (max-width: 430px) {
      max-width: calc(100vw - ${rem(64)});
      width: 100%;
    }

    *:not(svg) {
      min-width: inherit;
      width: inherit;
    }
  }  
`;

const StatusWrapper = styled.div<{
  hasZeroPrompts: boolean;
  hidden: boolean;
  shouldAnimate?: boolean;
}>(
  ({ hasZeroPrompts, hidden, shouldAnimate, theme }) => `
  background: ${
    hasZeroPrompts
      ? theme.palette.grey['200']
      : 'var(--prompt-status-background-color)'
  };
  border-radius: 12px 12px 0 0;
  color: ${
    hasZeroPrompts ? theme.palette.common.black : 'var(--prompt-status-color)'
  };
  font-size: ${rem(12)};
  margin: 0 auto;
  opacity: ${hidden ? 0.25 : 1};
  padding: ${rem(8)} ${rem(16)};
  position: relative;
  ${
    shouldAnimate
      ? `
    display: flex;
    bottom: ${hidden ? rem(-32) : 0};`
      : `
    display: ${hidden ? 'none' : 'flex'};
    `
  }
  column-gap: ${rem(16)};
  justify-content: space-between;
  transition: 250ms ease;
  white-space: nowrap;
  width: calc(100% - ${rem(32)});
  z-index: 1;

  @media (max-width: 768px) {
    font-size: ${rem(14)};
  }
`
);

const Status = styled.div`
  display: flex;
  gap: ${rem(4)};
`;

const Gradient = styled.div(
  ({ theme }) => `
  background: linear-gradient(
    to bottom,
    transparent 0%,
    ${theme.palette.common.white}88 40px,
    ${theme.palette.common.white} 156px
  );
  height: var(--prompt-gradient-height);
  pointer-events: none;
  position: absolute;
  left: 0;
  right: 0;
  top: -${rem(64)};
  z-index: 1;

  &.extended {
    height: calc(var(--prompt-gradient-height) + 44px);
  }

  @media (max-width: 390px) {
    height: calc(var(--prompt-gradient-height) + 16px);

    &.extended {
      height: calc(var(--prompt-gradient-height) + 60px);
    }
  }
`
);

export default {
  Wrapper,
  StatusWrapper,
  Status,
  Gradient
};
